import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'contactInitials',
    standalone: false
})
export class ContactInitialsPipe implements PipeTransform {
    transform(contact: string): string {
        const words = contact.split(' ');
        return words.map(w => w.charAt(0)).join('');
    }
}
